import {Component, computed, EventEmitter, Input, Output, signal} from '@angular/core';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';
import {ChecklistItem} from '../../entity/form-definition';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [LocalizationPipePipe],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {
  @Input() title: string | undefined;
  @Input() description: string | undefined;
  @Input() checklistItems: ChecklistItem[] = [];
  @Input() logoUrl: string | undefined;

  @Output() startSubmission = new EventEmitter<void>();

  checkedState = signal<boolean[]>([]);

  allChecked = computed(() => {
    const state = this.checkedState();
    return state.length > 0 && state.every(checked => checked);
  });

  ngOnChanges(): void {
    this.checkedState.set(this.checklistItems.map(() => false));
  }

  onCheckboxChange(index: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.checkedState.update(state => {
      const updated = [...state];
      updated[index] = checked;
      return updated;
    });
  }

  onStartSubmission(): void {
    if (this.allChecked()) {
      this.startSubmission.emit();
    }
  }
}
